export default __webpack_public_path__ + "1811d50.png";